import { render, staticRenderFns } from "./SectionRequirements.vue?vue&type=template&id=285b41e6&scoped=true"
import script from "./SectionRequirements.vue?vue&type=script&lang=ts"
export * from "./SectionRequirements.vue?vue&type=script&lang=ts"
import style0 from "./SectionRequirements.vue?vue&type=style&index=0&id=285b41e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b41e6",
  null
  
)

export default component.exports